import React from 'react';
import styles from './Header.module.css';

const Header = () => {
  return <header className={styles.header}>WeatherLy</header>;
};

export default Header;
